import * as logger from '@wix/fedops-logger';
import type { FedopsLogger } from '@wix/fedops-logger';

let fedopsLogger: FedopsLogger;

try {
  fedopsLogger = logger.create('wix-emails-viewer');
} catch (error) {
  fedopsLogger = {
    appLoaded: () => {},
  } as FedopsLogger;
}

export function useFedops() {
  return fedopsLogger;
}
